/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Search_Match_Count_OtherInputs */

const en_search_match_count_other = /** @type {(inputs: Search_Match_Count_OtherInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} matches`)
};

const zh_hans1_search_match_count_other = /** @type {(inputs: Search_Match_Count_OtherInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 个匹配`)
};

const pt_br2_search_match_count_other = /** @type {(inputs: Search_Match_Count_OtherInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} resultados`)
};

const es_search_match_count_other = /** @type {(inputs: Search_Match_Count_OtherInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} coincidencias`)
};

const fr_search_match_count_other = /** @type {(inputs: Search_Match_Count_OtherInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} résultats`)
};

const de_search_match_count_other = /** @type {(inputs: Search_Match_Count_OtherInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Treffer`)
};

const ru_search_match_count_other = /** @type {(inputs: Search_Match_Count_OtherInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Совпадений: ${i?.count}`)
};

const it_search_match_count_other = /** @type {(inputs: Search_Match_Count_OtherInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} risultati`)
};

/**
* | output |
* | --- |
* | "{count} matches" |
*
* @param {Search_Match_Count_OtherInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const search_match_count_other = /** @type {((inputs: Search_Match_Count_OtherInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Match_Count_OtherInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_search_match_count_other(inputs)
	if (locale === "pt-BR") return pt_br2_search_match_count_other(inputs)
	if (locale === "es") return es_search_match_count_other(inputs)
	if (locale === "fr") return fr_search_match_count_other(inputs)
	if (locale === "de") return de_search_match_count_other(inputs)
	if (locale === "ru") return ru_search_match_count_other(inputs)
	if (locale === "it") return it_search_match_count_other(inputs)
	return en_search_match_count_other(inputs)
});